module.exports = __webpack_public_path__ + "img/switch-table.00cddf37.svg";